import type { ConsumablesMatrixData } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

import type { ConsumablesFormValues } from "../../ConsumablesForm.types";

export const getInitialFormValues = (
  sku: string,
  consumablesMatrixData: ConsumablesMatrixData
): ConsumablesFormValues => {
  const consumableItem = consumablesMatrixData.items.find((item) => item.product.sku === sku);

  if (!consumableItem) {
    return {
      purchaseType: "regular",
      packagingFormatId: "",
      flavors: null,
      packagingFormat: null,
      quantity: "1",
    };
  }

  const packagingFormat = consumablesMatrixData.packagingFormats.find(
    (format) => format.id === consumableItem.packagingFormatId
  );

  const strengthSelector = consumableItem.strengthDetails ? String(consumableItem.strengthDetails.rating) : undefined;

  if (!packagingFormat) {
    return {
      purchaseType: consumableItem.purchaseType,
      packagingFormatId: "",
      packagingFormat: null,
      flavors: null,
      quantity: "1",
      strengthSelector,
    };
  }

  return {
    purchaseType: consumableItem.purchaseType,
    packagingFormatId: packagingFormat.id,
    packagingFormat: packagingFormat,
    flavors: null,
    quantity: "1",
    strengthSelector,
  };
};
